import { createI18n } from 'vue-i18n'
import en from './locales/en.js'
import zh from './locales/zh.js'

const messages = {
  en,
  zh
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'en', // 默认语言设置为英文
  fallbackLocale: 'zh', // 回退语言
  messages,
  globalInjection: true // 全局注入 $t 函数
})

export default i18n